import common from '../common'
const goBackOrForward = (a = -1) => {
    // 安卓
    if( !common?.isAndroid_ios() ) {
        if( window?.androidNative?.goBackOrForward ) { 
            window.androidNative.goBackOrForward(a)
        }else {
            window.history.back()
        }
    }else {
        if( window?.webkit?.messageHandlers?.h5Finish) {
            window?.webkit.messageHandlers.goBackOrForward.postMessage(a)
        }else {
            window.history.back()
        }
    }
}
export default goBackOrForward